FILTER_DEBOUNCE_INTERVAL = 500

###
# Методы для инциализации
###
initSelectedStatuses = (env) ->
  selectedStatuses = ORDER_STATUSES.map (status) =>
    Em.Object.create
      name:  status
      label: env.translate("order.status.#{status}")
      checked: false

  Em.A(selectedStatuses)


initSelectedRecurrence = (env)->
  selectedRecurrence = RECURRENCE_TYPES.map (type, i) =>
    Em.Object.create
      type: type
      checked: false
      label: env.translate("clients.recurrence_filter.#{type}")
      # Em.I18n.t('new')
      color: RECURRENCE_COLORS[i]

  Em.A(selectedRecurrence)


initSelectedOrderSources = (env) ->
  selectedOrderSources = ORDER_SOURCES.map (source) =>
    Em.Object.create
      name:  source
      label: env.translate("clients.order_source.#{source}")
      checked: false

  Em.A(selectedOrderSources)


initSortingParams = ->
  sortingParams = SORTING_PARAMS.map (param) =>
    Em.Object.create
      name: param
      label: "clients.sort.#{param}"
      selected: param == 'created_at'

  Em.A(sortingParams)


###
# Контроллер CRM
###
App.ClientsController = Em.Controller.extend
  env: Em.inject.service('environment')
  store: Em.inject.service('store')
  session: Em.inject.service('session')
  notifier: Em.inject.service()


  activeStatisticsPanel: '-active'

  # Свойства
  clientsBinding    : 'model'
  isLoadingClients  : false
  isLoading         : false
  showHeader        : Em.computed.or('isLoadingClients', 'clients')

  isBonusEnabled: Em.computed.oneWay('env.features.bonusEnabled')
  sortingParams: (->
    isBonusEnabled = @get('isBonusEnabled')
    params = initSortingParams().filter (param) -> param.name != 'bonus_count' or isBonusEnabled
    params
  ).property('isBonusEnabled')

  # Фильтры
  selectedClientRates   : Em.A([])
  selectedOrganizations : Em.A([])
  selectedRestaurants   : Em.A([])
  selectedCities        : Em.A([])
  selectedRecurrence    : Em.A([])
  selectedOrderSources  : Em.A([])
  selectedStatuses      : Em.A([])
  selectedTags          : Em.A([])
  selectedDishes        : []
  searchQuery           : ''
  dishesPage            : null
  dishesPageCount       : 0
  currentDishes         : Em.A([])
  isLoadingMoreDishes   : false

  initFilterFields: (->
    @set('selectedRecurrence',   initSelectedRecurrence(@get('env')))
    @set('selectedStatuses',     initSelectedStatuses(@get('env')))
    @set('selectedOrderSources', initSelectedOrderSources(@get('env')))
  ).on('init')

  minOrderDate          : null
  maxOrderDate          : null
  minOrderCount         : ''
  maxOrderCount         : ''
  minAverageCheck       : ''
  maxAverageCheck       : ''
  isBlacklisted         : false
  sortDescending        : false

  availableCities: (->
    @get('availableRestaurants').map( (r) -> r.get('city') ).uniq().sort().map (c) -> {name: c, id: c}
  ).property('availableRestaurants')

  severalCities: (->
    @get('availableCities').length > 1
  ).property('availableCities')


  onSelectedCityChanged: (->
    cities = @get('selectedCities').map (c) -> c.name
    selected = @get('availableRestaurants').filter (r) => cities.includes(r.get('city'))
    @set 'selectedRestaurants', selected
  ).observes('selectedCities.length')


  filtersDisabled: Em.computed.not('filtersEnabled')
  filtersEnabled:  Em.computed.empty('searchQuery')


  selectedParam: (->
    @get('sortingParams').find((param) => param.get('selected') == true)
  ).property('sortingParams.@each.selected')


  sortingBy: (->
    sortQuery     = @get('selectedParam')?.get('name') or 'created_at'
    sortQuery    += if @get('sortDescending') then ' desc' else ' asc'
  ).property('selectedParam', 'sortDescending')


  hasFilters: (->
    {
      order_status,
      order_source,
      delivery_at_min,
      delivery_at_max,
      dish_ids
    } = @get('filterQuery')

    order_status?.length > 0 or order_source?.length > 0 or delivery_at_min? or delivery_at_max?
  ).property('filterQuery')

  ###
  # Объект фильтр
  ###
  filterQuery: (->
    order_status = @get('selectedStatuses')
      .filter((s) -> s.checked)
      .map((s) -> s.name)
      .toArray()

    recurrence = @get('selectedRecurrence')
      .filter((r) -> r.checked)
      .map((r) -> r.type)
      .toArray()

    order_source = @get('selectedOrderSources')
      .filter((s) -> s.checked)
      .map((s) -> s.name)
      .toArray()

    organization_ids = @get('selectedOrganizations')
      .filter((s) -> s.checked)
      .map((s) -> s.id)
      .toArray()

    restaurant_ids = @get('selectedRestaurants')
      .map((s) -> s.id)
      .toArray()

    client_rates = @get('selectedClientRates')
      .filter((s) -> s.checked)
      .map((s) -> s.id)
      .toArray()

    dish_ids = @get('selectedDishes')
      .map((s) -> s.id)
      .toArray()
    client_tag_ids      = @get('selectedTags')

    delivery_at_min     = if @get('minOrderDate') then moment(@get('minOrderDate')).format('DD.MM.YYYY') else ''
    delivery_at_max     = if @get('maxOrderDate') then moment(@get('maxOrderDate')).format('DD.MM.YYYY') else ''

    sort                = @_checkString(@get('sortingBy'))
    average_check_min   = @_parseInt(@get('minAverageCheck'))
    average_check_max   = @_parseInt(@get('maxAverageCheck'))
    orders_count_min    = @_parseInt(@get('minOrderCount'))
    orders_count_max    = @_parseInt(@get('maxOrderCount'))
    is_blacklisted      = if @get('isBlacklisted') then true else undefined
    search_query        = null

    if @get('searchQuery').length > 0
      search_query = @get('searchQuery')

    result = {
      q: search_query,
      sort
    }

    if @get('filtersEnabled')
      Em.merge(result, {
        order_status,
        recurrence,
        dish_ids,
        client_tag_ids,
        restaurant_ids,
        organization_ids,
        order_source,
        delivery_at_min,
        delivery_at_max,
        average_check_min,
        average_check_max,
        orders_count_min,
        orders_count_max,
        is_blacklisted,
      })

    result
  ).property(
    'filtersEnabled',
    'searchQuery',
    'selectedStatuses.@each.checked',
    'selectedRecurrence.@each.checked',
    'selectedOrderSources.@each.checked',
    'selectedRestaurants.@each.checked',
    'selectedOrganizations.@each.checked',
    'selectedClientRates.@each.checked',
    'selectedTags.[]',
    'selectedDishes.[]',
    'minOrderDate',
    'maxOrderDate',
    'minAverageCheck',
    'maxAverageCheck',
    'minOrderCount',
    'maxOrderCount',
    'isBlacklisted',
    'sortingBy'
  )


  ###
  # Фильтрация
  ###
  onFilterChange: (->
    @get('_onFilterChangeDebounced')()
  ).observes(
    'searchQuery',
    'selectedStatuses.@each.checked',
    'selectedRecurrence.@each.checked',
    'selectedOrderSources.@each.checked',
    'selectedRestaurants.@each.checked',
    'selectedOrganizations.@each.checked',
    'selectedClientRates.@each.checked',
    'selectedTags.[]',
    'selectedDishes.[]',
    'minOrderDate',
    'maxOrderDate',
    'minAverageCheck',
    'maxAverageCheck',
    'minOrderCount',
    'maxOrderCount',
    'isBlacklisted',
    'sortingBy'
  ).on('init')

  clientsCountFmt: (->
    numeral(@get('clientsCount')).format('0,0')
  ).property('clientsCount')

  _bindedFilterChange: (->
    @_onFilterChange.bind(@)
  ).property()

  _onFilterChangeDebounced :(->
    _.debounce( @get('_bindedFilterChange'), FILTER_DEBOUNCE_INTERVAL, leading: true, trailing: true )
  ).property()

  _onFilterChange: ->
    @set('isLoadingClients', true)

    filterHash = @_objectCompact(@get('filterQuery'))

    @store.find('client', filterHash)
    .then((model) =>
      meta = @store.metadataFor('client')

      @setProperties({
        pageCount:    meta.page_count
        recurrenceDynamics:    meta.recurrence_dynamics
        clientsCount: meta.count
        page: 1
      })

      @set('model', model)
    )
    .finally( => @set('isLoadingClients', false))

  ###
  # Загрузка клиентов
  ###
  canLoadMore: (->
    @get('page') < @get('pageCount')
  ).property('pageCount', 'page')

  isLoadingMoreClients: false


  ###
  # Приватные функции
  ###
  _checkString: (str) ->
    str.trim() if str.trim() != ''

  _parseInt: (n) ->
    parseInt(n) if not isNaN(parseInt(n))

  _objectCompact: (obj) ->
    _.pick(obj, (v) -> v?)

  ###
  # Параметры графика клиентов
  ###
  chartShowDifferenceData: true

  chartHeight: Ember.computed(
    'activeStatisticsPanel',
    ->
      switch @get('activeStatisticsPanel')
        when '-active' then 115
        when '-active-widely' then 220
        else 0
  )

  chartHeightWithCheckbox: Ember.computed(
    'chartHeight',
    ->
      height = @get('chartHeight')

      if height
        height += 35

      height
  )

  chartHeightStyle: Ember.computed(
    'chartHeightWithCheckbox',
    ->
      Ember.String.htmlSafe("flex-basis: #{@get('chartHeightWithCheckbox')}px")
  )

  chartColumnFormat: Ember.computed 'chartColumnFormatIsPercent', ->
    if @get('chartColumnFormatIsPercent') then 'percent' else 'absolute'

  clientsBarLabels: Ember.computed 'selectedRecurrence.@each.checked', ->
    labels = []

    selectedRecurrence = @get('selectedRecurrence')

    if Ember.isArray(selectedRecurrence)
      if selectedRecurrence.filterBy('checked').length
        labels = selectedRecurrence.filterBy('checked').map((item) ->
          {
            key: item.get('type')
            label: item.get('label')
            color: item.get('color')
          }
        )
      else
        labels = selectedRecurrence.map((item) ->
          {
            key: item.get('type')
            label: item.get('label')
            color: item.get('color')
          }
        )

    labels

  chartColumnFormatIsPercent: true

  clientsBarDataPresent: Ember.computed(->
    return false if !@get('env.features.clientsChart')
    d = @get('clientsBarData')
    d && d.length && d.length > 0
  ).property('clientsBarData')

  clientsBarData: Ember.computed(->
    d = @get('recurrenceDynamics')
    return [] unless d
    d.map (item) ->
      item.date = moment(item.to).toDate()
      item

    # data = [{"new":51,"active":44,"returned":71,"cold":114,"dead":2526},{"new":43,"active":40,"returned":63,"cold":131,"dead":2519},{"new":44,"active":39,"returned":61,"cold":135,"dead":2514},{"new":40,"active":36,"returned":61,"cold":143,"dead":2509},{"new":40,"active":35,"returned":59,"cold":151,"dead":2501},{"new":40,"active":33,"returned":56,"cold":152,"dead":2500},{"new":36,"active":37,"returned":46,"cold":150,"dead":2505},{"new":35,"active":40,"returned":45,"cold":157,"dead":2494},{"new":35,"active":43,"returned":38,"cold":165,"dead":2488},{"new":33,"active":39,"returned":44,"cold":169,"dead":2479},{"new":32,"active":42,"returned":49,"cold":168,"dead":2468},{"new":39,"active":44,"returned":49,"cold":163,"dead":2462},{"new":38,"active":45,"returned":52,"cold":160,"dead":2458},{"new":39,"active":48,"returned":51,"cold":160,"dead":2451},{"new":43,"active":52,"returned":53,"cold":151,"dead":2446},{"new":46,"active":53,"returned":49,"cold":154,"dead":2443},{"new":50,"active":53,"returned":46,"cold":153,"dead":2441},{"new":51,"active":56,"returned":48,"cold":156,"dead":2430},{"new":56,"active":61,"returned":51,"cold":149,"dead":2424},{"new":56,"active":61,"returned":51,"cold":142,"dead":2427},{"new":61,"active":58,"returned":53,"cold":142,"dead":2421},{"new":65,"active":60,"returned":56,"cold":134,"dead":2417},{"new":67,"active":58,"returned":57,"cold":135,"dead":2412},{"new":71,"active":58,"returned":56,"cold":137,"dead":2405},{"new":75,"active":62,"returned":56,"cold":130,"dead":2402},{"new":72,"active":62,"returned":55,"cold":134,"dead":2395},{"new":71,"active":65,"returned":50,"cold":130,"dead":2394},{"new":72,"active":67,"returned":54,"cold":123,"dead":2388},{"new":72,"active":67,"returned":53,"cold":123,"dead":2381},{"new":68,"active":67,"returned":52,"cold":133,"dead":2370},{"new":70,"active":66,"returned":56,"cold":128,"dead":2366},{"new":66,"active":68,"returned":56,"cold":128,"dead":2361},{"new":67,"active":63,"returned":62,"cold":136,"dead":2348},{"new":68,"active":61,"returned":59,"cold":143,"dead":2340},{"new":72,"active":61,"returned":59,"cold":142,"dead":2334},{"new":66,"active":63,"returned":57,"cold":143,"dead":2328},{"new":66,"active":63,"returned":59,"cold":143,"dead":2323},{"new":62,"active":65,"returned":61,"cold":145,"dead":2316},{"new":60,"active":69,"returned":60,"cold":143,"dead":2311},{"new":56,"active":72,"returned":58,"cold":142,"dead":2308},{"new":59,"active":73,"returned":56,"cold":142,"dead":2302},{"new":57,"active":74,"returned":60,"cold":134,"dead":2301},{"new":52,"active":75,"returned":57,"cold":136,"dead":2301},{"new":49,"active":77,"returned":53,"cold":137,"dead":2297},{"new":50,"active":78,"returned":54,"cold":134,"dead":2293},{"new":53,"active":78,"returned":61,"cold":129,"dead":2285},{"new":56,"active":78,"returned":59,"cold":124,"dead":2286},{"new":55,"active":78,"returned":58,"cold":122,"dead":2286},{"new":56,"active":81,"returned":61,"cold":113,"dead":2283},{"new":57,"active":80,"returned":61,"cold":107,"dead":2282},{"new":59,"active":81,"returned":58,"cold":107,"dead":2278},{"new":58,"active":84,"returned":56,"cold":108,"dead":2273},{"new":59,"active":85,"returned":55,"cold":112,"dead":2265},{"new":61,"active":84,"returned":56,"cold":113,"dead":2259},{"new":57,"active":87,"returned":58,"cold":106,"dead":2259},{"new":59,"active":86,"returned":51,"cold":107,"dead":2257},{"new":65,"active":84,"returned":53,"cold":106,"dead":2249},{"new":63,"active":84,"returned":53,"cold":106,"dead":2245},{"new":64,"active":80,"returned":53,"cold":116,"dead":2235},{"new":62,"active":81,"returned":51,"cold":119,"dead":2229}]

    # data = data.slice(0, 30)
    # data = data.slice(0, 20)
    # data = data.slice(0, 10)
    # data = data.slice(0, 5)
    # data = data.slice(0, 1)

    # i = 0

    # dd = data.map (item) ->
      # item.date = moment().add(i++, 'days').toDate()
      # item

    # console.log dd

    # dd
  ).property('recurrenceDynamics')

  canLoadMoreDishes: (->
    @get('dishesPage') < @get('dishesPageCount')
  ).property('dishesPage', 'dishesPageCount')


  ###
  # События
  ###
  actions:
    openTagsPopup: ->
      @get('miniPopups').send('openPopup', 'tags-popup')
      false

    closeTagsPopup: (ids) ->
      tagIds = ids
      data = @_objectCompact(@get('filterQuery'))
      queryParams = Em.$.param( data )

      adapter = @get('store').adapterFor('application')
      host = adapter.get('host')
      namespace = adapter.get('namespace')
      headers = adapter.get('headers')
      URL = "#{host}/#{namespace}/clients/update_all?#{queryParams}"
      ajaxProps =
        url: URL
        headers: headers
        type: 'PUT'
        processData: false
        contentType: "application/json; charset=utf-8"
        data: JSON.stringify(tagIds)
        statusCode: 
          200: () =>
            @get('notifier').pushNotification
                type:     'success'
                title:    Em.I18n.t('c.client_tags.notification.title')
                message:  Em.I18n.t('c.client_tags.notification.message')
            @get('miniPopups').send('closePopup', 'tags-popup')
            @get('_onFilterChangeDebounced')()
            @set('isLoading', false)
            
      Em.$.ajax(ajaxProps)
      false
    
    exportCSV: ->
      adapter = @get('store').adapterFor('application')
      token   = @get('session.apiKey')

      url = adapter.buildURL('client')

      paramsHash = @_objectCompact(Em.merge(@get('filterQuery'), {
        all: true,
        token: token
      }))

      queryParams = Em.$.param( paramsHash )

      csvLink = "#{url}.csv?#{queryParams}"
      window.open(csvLink, '_blank')
      false

    exportXLS: ->
      adapter = @get('store').adapterFor('application')
      token   = @get('session.apiKey')

      url = adapter.buildURL('client')

      paramsHash = @_objectCompact(Em.merge(@get('filterQuery'), {
        all: true,
        token: token
      }))

      queryParams = Em.$.param( paramsHash )

      xlsLink = "#{url}.xlsx?#{queryParams}"
      window.open(xlsLink, '_blank')
      false

    toggleChartPercentFormat: ->
      @toggleProperty('chartColumnFormatIsPercent')
      false

    toggleStatisticsPanel: ->
      active = @get('activeStatisticsPanel')

      switch active
        when null then @set('activeStatisticsPanel', '-active')
        when '-active' then @set('activeStatisticsPanel', '-active-widely')
        when '-active-widely' then @set('activeStatisticsPanel', null)

      false

    clientSelected: (client) ->
      @transitionToRoute('clients.client', client)

    loadMore: ->
      if @get('canLoadMore') and not @get('isLoadingMoreClients')
        @set('isLoadingMoreClients', true)
        @incrementProperty('page')
        @store.find('client', _.merge({page: @get('page')}, @get('filterQuery')))
        .then (clients) =>
          @set('isLoadingMoreClients', false)
          @get('model').pushObjects(clients.toArray())
      false

    setSorting: (paramName) ->
      if paramName == @get('selectedParam.name')
        @toggleProperty('sortDescending')
      else
        @get('sortingParams').forEach (param) =>
          if param.get('name') == paramName
            param.set('selected', true)
          else
            param.set('selected', false)

      false

    mouseEnterColumnClientsBar: (data) ->
      console.log data
      false

    mouseLeaveColumnClientsBar: (data) ->
      console.log data
      false

    clickColumnClientsBar: (data) ->
      console.log data
      false

    queryDishes: (defer, query) ->
      @set('isLoadingMoreDishes', true)
      @store.find('dish', search: query)
        .then((dishes) =>
          # Установить данные в currentDishes
          @set('dishesPageCount', dishes.meta.page_count)
          @set('dishesPage', dishes.meta.page)
          @set('currentDishes', dishes)
          @set('isLoadingMoreDishes', false)
          # Затем выполнить defer.resolve с currentDishes
          defer.resolve(@get('currentDishes'))
        , defer.reject)

      false
      

    loadMoreDishes: (query) ->
      if @get('canLoadMoreDishes') and not @get('isLoadingMoreDishes')
        @set('isLoadingMoreDishes', true)
        @incrementProperty('dishesPage')
        @store.find('dish', _.merge({page: @get('dishesPage'), search: query}))
          .then (dishes) =>
            @set('isLoadingMoreDishes', false)
            @get('currentDishes').pushObjects(dishes.toArray())
      false   